import angular from 'angular'
import invoice from './invoice1'
import ovatBill from './ovatBill'
import redWordInfo from './redWordInfo'
import sourceError from './sourceError'
import eleInvoice from './eleInvoice'
import vehicleInvoice from './vehicleInvoice'
import rollTypeInvoice from './rollTypeInvoice'
import invoiceException from './invoiceException'

export default angular
    .module('outputManage.FOManage', [invoice, redWordInfo, ovatBill, sourceError, eleInvoice, vehicleInvoice, rollTypeInvoice,invoiceException])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('outputManage.FOManage', {
            url: '/ovat',
            template: '<div ui-view></div>',
            abstract: true,
            title: '填开管理',
        })
        // .state()
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/index.js